import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';

type ToastType = 'info' | 'success' | 'warning';

export function Toast() {
  return <ToastContainer position="top-right" newestOnTop />;
}

export function showToast(message: string, type: ToastType) {
  switch (type) {
    case 'success':
      return toast.success(message);
    case 'info':
      return toast.info(message);
    case 'warning':
      return toast.warn(message);
    default:
      return toast(message);
  }
}
